import { Card } from "@/src/components/cards";
import { openConfirmDialog, openDrawer } from "@/src/components/dialogs";
import { UploadCards } from "@/src/components/uploadSpots";
import {
  Hospitalisation,
  Patient,
  Toxicity
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  formatDate,
  getDayCount,
  getItemId,
  getUserId,
  getUserShortName,
  isToday,
} from "@/src/utils/utils";
import { FieldAnswersList } from "../../fields/fieldsAnswersList";
import { ReferenceFieldsForm } from "../../fields/referenceFieldsForm";

export default function ToxicityCard({
  item,
  patient,
  parent,
  onClick,
  onChange,
}: {
  item: Toxicity;
  patient: Patient;
  parent: Hospitalisation;
  onClick: () => void;
  onChange: (item: Toxicity) => void;
}) {
  let refAnswer = item?.content;
  let reference = item?.reference;

  async function openForm(item: Toxicity) {
    let reference = item?.reference;
    if (!reference) {
      throw new Error("No reference in patientItem");
    }
    await openDrawer({
      title: `${reference?.name}`,
      content: (
        <ReferenceFieldsForm
          patient={patient}
          currentAnswers={item.content?.fieldAnswers || []}
          reference={reference}
          onChange={(newValue) => {
            if (!item.content) return;
            item.content.fieldAnswers = newValue;
          }}
        />
      ),
      onConfirm: async () => {
        item = await apiFetch(
          "toxicities",
          "addOne",
          { toxicity: item },
          "Erreur lors de l'enregistrement de la toxicité"
        );
        onChange?.(item);
      },
    });
  }

  return (
    <Card
      color="blue"
      title={"Toxicité"}
      onClick={async () => {
        // await openEvolutionItemStandardForm({
        //   item,
        //   patient,
        //   onConfirm: async (newItem) => {
        //     newItem = await apiFetch("toxicities", "addOne", {
        //       toxicity: newItem,
        //     });
        //     onChange?.(newItem);
        //   },
        // });
        await openForm(item);
      }}
      onDelete={
        getUserId() == getItemId(item.creator) && isToday(item._date)
          ? async () => {
              await openConfirmDialog({
                content: "Voulez-vous vraiment supprimer cet élément ?",
                onConfirm: async () => {
                  await apiFetch("toxicities", "deleteOne", {
                    id: item.id,
                  });
                  onChange?.(item);
                },
              });
            }
          : undefined
      }
      leading={
        <div className=" mtop5 left br mright5">
          <div className="bold">{getDayCount(parent?._date, item._date)}</div>
          <div className="gray">{formatDate(item._date, "HH:mm")}</div>
        </div>
      }
    >
      <div className="c1 ">
        <div className="bold ">{reference?.name}</div>

        {item.notes ? <div className="gray">{item.notes}</div> : null}

        {item.conclusion ? <div className="bold">{item.conclusion}</div> : null}

        <FieldAnswersList
          patient={patient}
          reference={reference}
          answers={refAnswer?.fieldAnswers || []}
        />

        <div className="gray ">{getUserShortName(item?.creator)}</div>
        <UploadCards uploads={item.uploads} />
      </div>

    </Card>
  );
}
